import React from 'react';

import { BASE_ICONS } from 'src/components/svg';
import { scssVariables } from 'src/helpers';
import { MCButton } from './MCButton';

export const CloseBtn = React.memo(
  ({
    onClose,
    fill = scssVariables['colors-mc-primary'],
    className = '',
    style = {
      position: 'absolute',
      top: 2,
      right: 2
    },
    width = 34,
    iconProps = {}
  }) => (
    <MCButton
      className={className}
      type={'button'}
      style={style}
      onClick={onClose}
      iconname={BASE_ICONS.CLOSE}
      fill={fill}
      width={width}
      padding={10}
      light
      {...iconProps}
      circle
    />
  )
);
CloseBtn.displayName = 'CloseBtn';
